import { sRGBEncoding } from 'three';

export function cleanTexture(texture: THREE.Texture) {
  texture.flipY = false;
  texture.encoding = sRGBEncoding;
}